// extracted by mini-css-extract-plugin
export default {"title":"RedactGameComponent_title__+qzSL","wrapper_button":"RedactGameComponent_wrapper_button__759X3"};